import { CgBreakpoints } from "../../components/common/cgBreakpoints";
import { MediaImage } from "../media/mediaImage";


export class Livecast {
    options = {
        delay: 60000,
        limit: 20
    };

    totalItems = 0;

    // staff
    timer;
    list;
    button;

    constructor() {
        this.init();
    }

    init() {
        this.list = $('.livecast-list');

        this.searchCustom();

        if (!this.list.length || this.list.length > 1 || !this.list.data('src')) {
            return;
        }

        this.button = $('[data-container="livecast-list"]');

        this.timer = window.setInterval(() => {
            this.ajaxAction('update');
        }, this.options.delay);

        this.bindEvents();
    }

    bindEvents() {
        this.button.on('click', (e) => {
            e.preventDefault();
            this.ajaxAction('load');
        });
    }

    ajaxAction(mode) {
        let href = '';

        this.list.addClass('livecast-list--loading');

        if (mode === 'update') {
            href = this.list.data('src');
        }

        if (mode === 'load') {
            href = this.button.prop('href');
        }

        $.ajax({
            url: href,
            method: 'GET',
            data: {
                fragment: true
            }
        })
            .done((res) => {

                if (typeof res == "string") {
                    res = JSON.parse(res);
                }

                if ((res.errors === undefined)
                    || ((res.errors !== undefined) && res.errors.length)) {
                    this.onError(res.errors);
                    return;
                }

                if (mode === 'update') {
                    if (!this.wasUpdated(res)) {
                        return;
                    }

                    this.updateItems(res);
                }

                if (mode === 'load') {
                    this.loadItems(res);
                }

                this.loadImages();

                if (!this.isMobile() && this.hasNewPage(res)) {
                    this.reloadWindow();
                }
            })
            .fail((err) => this.onError(err))
            .always(() => this.onAlways());
    }

    updateItems(res) {
        this.list.html(res.data.html);
        this.totalItems = res.data.totalItems;
    }

    loadItems(res) {
        this.list.append(res.data.html);
        res.data.nextPageUrl ? this.button.prop('href', res.data.nextPageUrl) : this.button.remove();
    }

    onError(err) {
        console.debug('Livecast Error ', err);
        this.list.addClass('livecast-list--error');
        this.stopUpdate();
    }

    onAlways() {
        if (!this.list.is('.livecast-list--error')) {
            this.list.removeClass('livecast-list--loading');
        }
    }

    // auxiliary
    loadImages() {
        new MediaImage();
    }

    stopUpdate() {
        window.clearInterval(this.timer);
    }

    wasUpdated(res) {
        return 0 < this.totalItems && this.totalItems < res.data.totalItems;
    }

    hasNewPage(res) {
        return res.data.totalItems !== 1 && res.data.totalItems % options.limit >= 1;
    }

    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }

    reloadWindow() {
        window.location.reload(true);
    }

    searchCustom() {
        let hash = window.location.hash;
        if (hash && hash.startsWith('#message_', 0)) {
            hash = hash.replace('#message_', '/bb3contentlive/message/');
            $.ajax({
                url: hash,
                method: 'GET',
                data: {}
            })
                .done((res) => {
                    $('#featured-message').html(res);
                    this.loadImages();
                })
                .fail((err) => this.onError(err));
        }
    }
}
